import { Loader } from "@googlemaps/js-api-loader"
import { MarkerClusterer, GridAlgorithm } from "@googlemaps/markerclusterer"
import map from 'lodash/map'
import each from 'lodash/each'
import slugify from "slugify"

import { app } from '../utils/store'

import { MAPS_STYLE } from '../utils/map'

const getPlaceCountryCode = (place) => {
    const country = place.address_components?.find((component) => component.types.includes('country'))
    return country ? country.short_name.toLowerCase() : ''
}

export default class Maps {
    constructor({
        element,
        zoom = {},
        infowindow = null,
        coordinates = {},
        controls = false,
        ui = false,
        wheel = false,
        fullscreen = false,
        streetView = false,
        mapTypeControl = false,
        draggable = false,
        api = {
            namespace: null,
            endpoint: null,
            arguments: null
        }
    }, search = null) {
        if (element) {
            this.element = element

            this.map = {
                zoom: zoom,
                coordinates: coordinates,
                controls: controls,
                ui: ui,
                wheel: wheel,
                fullscreen: fullscreen,
                streetView: streetView,
                mapTypeControl: mapTypeControl,
                draggable: draggable,
            }
        }

        this.MapLoader = new Loader({
            apiKey: maps.APIkey,
            version: 'weekly',
            // callbacks: ['initAutocomplete'],
            libraries: ['places', 'geometry'],
            region: 'it' // NOOO BRUNO maybe better to update it with a variable linked to the user locale
        })

        if (api.namespace && api.endpoint) { this.api = api }
    }

    async create({ search = null, markers = null, markersList = null, single = false }) {

        this.locations = await this.getLocationsAPI({
            namespace: 'geolocation',
            endpoint: 'stores'
        })

        // this.places = await this.getLocationsAPI({
        //     namespace: 'geolocation',
        //     endpoint: 'available'
        // })

        this.MapLoader
            .load()
            .then(async () => {
                const { Map } = await google.maps.importLibrary("maps")

                this.gmap = new google.maps.Map(
                    this.element,
                    {
                        styles: MAPS_STYLE,
                        center: this.map.coordinates,
                        zoom: this.map.zoom.value,
                        zoomControl: this.map.zoom.controls.enable,
                        zoomControlOptions: this.map.controls.options,
                        minZoom: 6,
                        disableDefaultUI: this.map.ui,
                        scrollwheel: this.map.wheel,
                        fullscreenControl: this.map.fullscreen,
                        streetViewControl: this.map.streetView,
                        mapTypeControl: this.map.mapTypeControl,
                        gestureHandling: this.map.draggable,
                    }
                )

                if (search) {
                    this.createSearch(search, {
                        // available: this.places,
                        autocomplete: true,
                        geolocate: search.geolocate ? search.geolocate : null
                    })
                }

                console.log(markers);
                console.log(markersList);
                if (markersList) {
                    this.createMarkers(this.locations, markersList, single)
                    //this.createClusters()
                } else {
                    if (markers) {
                        this.createMarkers(this.locations)
                        this.createClusters()
                    }
                }
            })
    }

    getLocationsAPI = async (api) => {
        //let request = await fetch(`${config.api}${api.namespace}/${api.endpoint}/`);
        let request = await fetch(`https://www.febalcasa.com/wp-content/uploads/json/stores.json`)

        if (request.status === 200) {
            let response = await request.json()
            return response
        }
    }

    createMarkers = (locations, markersList = null, single = false) => {
        if (markersList) {
            console.log(this.map.coordinates);
            locations = markersList;
            var bounds = new google.maps.LatLngBounds();
            bounds.extend(this.map.coordinates);
        }
        this.markers = map(locations, (item, index) => {
            const kind = item.getAttribute('data-kind')
            if (kind == "febal-casa-store" || kind == "corner") {
                let text = "<div class='infobox' data-mark='" + item.getAttribute('data-id') + "'><p class='h5 name'>" + item.getAttribute('data-title') + "</p><br><p>" + item.getAttribute('data-address') + "</p><br>"

                text += '<a href="https://www.google.com/maps/dir/?api=1&destination=' + item.getAttribute('data-lat') + ',' + item.getAttribute('data-lng') + '" class="" target="_blank">Vai allo store</a></div>'


                const marker = new google.maps.Marker({
                    map: this.gmap,
                    title: item.getAttribute('data-title'),
                    position: { lat: parseFloat(item.getAttribute('data-lat')), lng: parseFloat(item.getAttribute('data-lng')) },
                    icon: {
                        url: `${config.theme}/dist/img/vectors/icon-marker.svg`
                    },
                })

                let infowindow = new google.maps.InfoWindow({
                    content: text,
                    maxWidth: 360,
                    //disableAutoPan: true,
                });

                marker.addListener("click", () => {
                    infowindow.open({
                        anchor: marker,
                        map: this.gmap,
                    });
                });

                if (markersList) {
                    bounds.extend(new google.maps.LatLng(item.getAttribute('data-lat'), item.getAttribute('data-lng')));
                }

                return marker
            }
        })

        if (markersList && single == false) {
            this.gmap.fitBounds(bounds);
            this.gmap.panToBounds(bounds);
        }
    }

    createClusters = () => {
        let icon = window.btoa(`
            <svg fill="${design.color.primary}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
                <circle cx="120" cy="120" opacity="1" r="70" />
                <circle cx="120" cy="120" opacity=".7" r="90" />
                <circle cx="120" cy="120" opacity=".3" r="110" />
            </svg>`)

        let renderer = {
            render: ({ count, position }) =>
                new google.maps.Marker({
                    label: { text: String(count), color: "#FFFFFF", fontSize: "12px", fontWeight: "400" },
                    icon: {
                        url: `data:image/svg+xmlbase64,${icon}`,
                        scaledSize: new google.maps.Size(45, 45),
                    },
                    position,
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                })
        }

        new MarkerClusterer({
            map: this.gmap,
            markers: this.markers,
            algorithm: new GridAlgorithm({ gridSize: 60 }),
            renderer
        })
    }

    createSearch = async (search, { available = null, autocomplete = false, geolocate = null }) => {
        this.search = search

        this.search.input.onkeydown = (event) => {
            if (event.key === 'Enter' && event.target.type !== 'submit') { event.preventDefault() }
        }

        // this.search = new google.maps.places.SearchBox(this.search)



        if (autocomplete) {
            var region = "it"; // NOOO Retrieve region from lang
            switch (region) {
                case 'it':
                    //italia
                    var defaultBounds = {
                        north: 47.100000,
                        south: 36.600000,
                        east: 18.500000,
                        west: 6.600000,
                    };
                    break;
                case 'en':
                    //europa
                    var defaultBounds = {
                        north: 70.100000,
                        south: 35.000000,
                        east: 45.000000,
                        west: 10.000000,
                    };
                    break;
                case 'es':
                    //spagna
                    var defaultBounds = {
                        north: 45.100000,
                        south: 35.600000,
                        east: 5.500000,
                        west: -10.600000,
                    };
                    break;
                case 'fr':
                    //francia
                    var defaultBounds = {
                        north: 43.800000,
                        south: 36.000000,
                        east: 3.000000,
                        west: 9.300000,
                    };
                    break;
                case 'de':
                    //germania
                    var defaultBounds = {
                        north: 55.100000,
                        south: 47.200000,
                        east: 15.100000,
                        west: 5.9000000,
                    };
                    break;
                case 'ru':
                    //russia
                    var defaultBounds = {
                        north: 71.200000,
                        south: 41.200000,
                        east: 175.200000,
                        west: 20.200000,
                    };
                    break;
                case 'el':
                    //grecia
                    var defaultBounds = {
                        north: 42.200000,
                        south: 34.600000,
                        east: 28.200000,
                        west: 19.400000,
                    };
                    break;
            }

            this.search.autocomplete = new google.maps.places.Autocomplete(this.search.input, {
                fields: ["formatted_address", "geometry", "name", "address_components"],
                types: ['geocode'],
                strictBounds: false,
                bounds: defaultBounds,
                region: region
            })

            this.search.autocomplete.addListener("place_changed", (event) => {
                let requestPlace = this.search.autocomplete.getPlace()

                if (!requestPlace.geometry || !requestPlace.geometry.location) {
                    // TODO: Open a Modal from ModalManager.create()
                    window.alert("No details available for input: '" + requestPlace.name + "'")
                    return
                }

                const countryCode = getPlaceCountryCode(requestPlace)
                this.search.input.setAttribute('data-map', requestPlace.geometry.location.lat() + '|' + requestPlace.geometry.location.lng() + '|' + requestPlace.formatted_address + '|' + countryCode);

                // If the place has a geometry, then present it on a map.
                // if (requestPlace.geometry.viewport) {
                //     this.gmap.fitBounds(requestPlace.geometry.viewport)
                // } else {
                //     this.gmap.setCenter(requestPlace.geometry.location)
                // }

                // this.gmap.setZoom(this.map.zoom.value)
            })
            if (this.gmap) {
                //this.search.autocomplete.bindTo("bounds", this.gmap)


                this.search.autocomplete.addListener("place_changed", (event) => {
                    let requestPlace = this.search.autocomplete.getPlace()

                    if (!requestPlace.geometry || !requestPlace.geometry.location) {
                        // TODO: Open a Modal from ModalManager.create()
                        window.alert("No details available for input: '" + requestPlace.name + "'")
                        return
                    }

                    // If the place has a geometry, then present it on a map.
                    // if (requestPlace.geometry.viewport) {
                    //     this.gmap.fitBounds(requestPlace.geometry.viewport)
                    // } else {
                    //     this.gmap.setCenter(requestPlace.geometry.location)
                    // }

                    // this.gmap.setZoom(this.map.zoom.value)
                })
            }
        }

        if (geolocate) {
            this.createLocateUser()
        }
    }

    createLocateUser = () => {
        this.search.geolocate.onclick = (event) => {
            event.preventDefault()
            event.stopPropagation()
            navigator.geolocation.getCurrentPosition(
                // On Success
                (position) => {
                    let map = this.gmap
                    let coordinates = {
                        lat: parseFloat(position.coords.latitude),
                        lng: parseFloat(position.coords.longitude)
                    }

                    map.setCenter(coordinates)
                    map.setZoom(this.map.zoom.value)
                    new google.maps.Marker({
                        map: map,
                        position: (coordinates),
                        title: `${event.target.name}`,
                        // icon: {
                        //     // size: new google.maps.Size(24, 30),
                        //     // scaledSize: new google.maps.Size(24, 30),
                        //     // origin: new google.maps.Point(0, 0),
                        //     // anchor: new google.maps.Point(17, 34),
                        //     url: `${config.theme}/dist/img/vectors/icon-marker-user.svg`
                        // },
                    })
                },
                // On Error
                (error) => {
                    // alert('Il tuo dispositivo non supporta la geolocalizzazione.')
                    console.error(error)
                }
            )

            navigator.geolocation.watchPosition(
                // On Success
                (position) => { },
                // On Error
                (error) => { if (error.code == error.PERMISSION_DENIED) { app.html.setAttribute('geolocate', false) } }
            )
        }

    }
}